import React from "react";
import "../css/styles.css";

class Navbar extends React.Component {
  constructor() {
    super();
    this.state = {
      pageloader: false,
      loaderToggle: false,
    };

  }
  componentDidMount() {
    window.addEventListener("beforeinstallprompt", this.handler);
  }

  handler = (event) => {
    this.setState({ supportsPWA: true, promptInstall: event });
    event.preventDefault();
    // console.log("👍", "beforeinstallprompt", event);

    window.deferredPrompt = event;
  };

  onClickPWA = (e) => {
    // console.log("👍", "butInstall-clicked");
    const promptEvent = window.deferredPrompt;
    if (!promptEvent) {
      // The deferred prompt isn't available.
      return;
    }
    // Show the install prompt.
    promptEvent.prompt();
    // Log the result
    const result = promptEvent.userChoice;
    // console.log("👍", "userChoice", result);
    // deferredPrompt.userChoice
    result.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        // console.log("User accepted the A2HS prompt");
        this.setState({ supportsPWA: false });
        // this.props.eventStartPWA({ supportsPWA: false });
      } else {
        // console.log("User dismissed the A2HS prompt");
      }
      window.deferredPrompt = null;
    });
  };
  render() {
    return (
      <div>
        <nav className="navbar  navbar-dark bg-dark " id="mainNav">
          <div className="container">
            <a
              className="navbar-brand"
              href="#page-top"
              style={{ fontFamily: "TimberwolfRegular", fontSize: "30px" }}
            >
              Super Heroes
            </a>
            {this.state.supportsPWA && (
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarResponsive"
                aria-controls="navbarResponsive"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={() => this.onClickPWA()}
              >
                Install App
                {/* <i class="fas fa-bars ms-1"></i> */}
                <i class="fas fa-angle-double-down ms-1"></i>
              </button>
            )}
          </div>
        </nav>
      </div>
    );
  }
}

export default Navbar;
